module.exports = __webpack_public_path__ + "app/images/footer/BBJ BPTW 2021 white text-05.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/footer/BBJ BPTW 2021 white text-05.png
// module id = 469
// module chunks = 0